import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Loader from 'apollo-react/components/Loader';
import React from 'react';

import '../assets/react-toolbox/theme.css';
import { JOURNEY_BUILDER_PATH } from '../Shared/Routing/routingPaths';
import CustomIntlProvider from '../Shared/CustomIntlProvider';
import GoogleAnalytics from './GoogleAnalytics';
import JourneyBuilderArea from '../JourneyBuilder';

const appFontFamily = '"Noto Sans", "Helvetica", "Arial", sans-serif';

const styles = theme => ({
  '@global': {
    '*, *::before, *::after': {
      fontFamily: `${appFontFamily} !important`,
      boxSizing: 'border-box',
    },
    html: {
      margin: 0,
      padding: 0,
      overflowX: 'hidden',
      maxWidth: 'calc(100vw)',
    },
    body: {
      margin: 0,
      padding: 0,
      fontFamily: `${appFontFamily} !important`,
      overflowX: 'hidden',
      maxWidth: 'calc(100vw)',
      overflowY: 'hidden',
      height: '100%',
    },
    a: {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
  },
});

export const Root = ({ store, isAppDataLoaded }) => (
  // We don't have app data (window.App); likely because we're running the UI
  // via node on dev box. Display Loader while data is being fetched.
  // We have window.App OR it could not be loaded (api isn't running); do a normal render
  <React.Fragment>
    {!isAppDataLoaded && <Loader />}
    <Provider store={store}>
      <CustomIntlProvider>
        <Router>
          <Switch>
            <Route
              path={JOURNEY_BUILDER_PATH}
              component={JourneyBuilderArea}
              breadcrumb="JourneyBuilder"
            />
          </Switch>
          <Route component={GoogleAnalytics} />
        </Router>
      </CustomIntlProvider>
    </Provider>
  </React.Fragment>
);

Root.displayName = 'Root';

export default withStyles(styles, { name: 'Root' })(Root);



// WEBPACK FOOTER //
// ./src/Root/Root.js